<template>
	<app-title-bar
		:icon="['fas', 'fa-box']"
		:subtitle="`Product Group ${code}`"
		:title="productGroup?.name">
		<template #icon>
			<product-category-icon
				v-if="productGroup"
				:category="productGroup.analysis_group?.master_group?.code"
				size="medium"></product-category-icon>
		</template>

		<app-button
			v-if="productGroup"
			:to="`/product-data/master-groups/${productGroup.analysis_group?.master_group?.code}`"
			class="ml-2"
			icon="fa-circle-left">
			Back
		</app-button>
	</app-title-bar>

	<div v-if="productGroup" class="grid grid-cols-1 xl:grid-cols-2 gap-4">
		<app-panel v-for="subGroup in productGroup.sub_groups" :key="subGroup.code">
			<div class="flex">
				<sub-group-form
					v-if="authStore.isAbleTo(['edit-stock-id'])"
					:subgroup="subGroup"
					@completed="onSubgroupEdited"></sub-group-form>

				<div class="flex items-center justify-center w-48 mr-10">
					<img v-if="subGroup?.picture" :src="subGroup.picture" alt="Base64 Image" />
					<div v-else>
						<!--						<app-icon :icon="['fas','fa-warning']"></app-icon>-->
						MISSING PICTURE
					</div>
				</div>
				<div class="flex-1 mx-auto">
					<ul>
						<li class="flex justify-between py-3 border-b border-gray-300">
							<span class="font-semibold text-gray-700">PRODUCT CODE</span>
							<a
								class="text-gray-600 font-bold"
								:href="`/product-data/items/${subGroup.code}`"
								>{{ subGroup.code }}</a
							>
						</li>
						<li class="flex justify-between py-3 border-b border-gray-300">
							<span class="font-semibold text-gray-700">PRODUCT NAME</span>
							<span class="text-gray-600 text-right pl-5">{{ subGroup.name }}</span>
						</li>
						<li class="flex justify-between py-3 border-b border-gray-300">
							<span class="font-semibold text-gray-700">WEIGHT</span>
							<span class="text-gray-600"
								>{{
									parseFloat((subGroup.weight * 1000).toString()).toFixed(2)
								}}kg</span
							>
						</li>
						<li class="flex justify-between py-3 border-b border-gray-300">
							<span class="font-semibold text-gray-700">FINISH</span>
							<span class="text-gray-600 text-right pl-5">{{
								subGroup.profiles?.finish
							}}</span>
						</li>
						<li class="flex justify-between py-3 border-gray-300">
							<span class="font-semibold text-gray-700">DESCRIPTION</span>
							<span class="text-gray-600 text-right pl-5">{{
								subGroup.profiles?.id_description
							}}</span>
						</li>
					</ul>
				</div>
			</div>
		</app-panel>
	</div>

	<!-- Subgroup skeletons -->
	<div v-else class="grid grid-cols-1 xl:grid-cols-2 gap-4">
		<app-panel v-for="n in 6" :key="n">
			<div class="flex animate-pulse">
				<div class="flex items-center justify-center mr-5">
					<div class="mx-5 h-48 w-48 bg-gray-200 rounded"></div>
				</div>
				<div class="flex flex-col w-full items-end">
					<div class="h-6 bg-gray-200 rounded w-1/3 my-2"></div>
					<div class="h-6 bg-gray-200 rounded w-2/3 my-2"></div>
					<div class="h-6 bg-gray-200 rounded w-1/5 my-2"></div>
					<div class="h-6 bg-gray-200 rounded w-2/3 my-2"></div>
					<div class="h-6 bg-gray-200 rounded w-full my-2"></div>
				</div>
			</div>
		</app-panel>
	</div>
</template>

<script lang="ts" setup>
	import { onMounted, ref } from 'vue'
	import { useRoute } from 'vue-router'
	import type { ProductGroup } from '@/data/schema/product-group'
	import AppPanel from '@/components/layout/panel/AppPanel.vue'
	import ProductCategoryIcon from '@/components/partials/icons/ProductCategoryIcon.vue'
	import ProductGroupService from '@/services/product-group'
	import SubGroupForm from '@/components/partials/product-data/SubGroupForm.vue'
	import useAuthStore from '@/stores/auth'

	const productGroup = ref<ProductGroup>()
	const authStore = useAuthStore()

	const loading = ref(false)

	const route = useRoute()
	const code = typeof route.params.code === 'string' ? route.params.code : route.params.code[0]

	const load = async () => {
		loading.value = true
		try {
			const api = new ProductGroupService()
			const response = await api.get(code)
			productGroup.value = response.data.data
		} catch (error) {
			console.error('Error fetching product group:', error)
		} finally {
			loading.value = false
		}
	}

	const onSubgroupEdited = (updatedSubgroup) => {
		if (!productGroup.value) return


		console.log(updatedSubgroup.picture)
		// search the array for the index
		const index = productGroup.value.sub_groups.findIndex(
			(s) => s.code === updatedSubgroup.code
		)
		// Oddly cant find it then exit early
		if (index === -1) return
		Object.assign(
			productGroup.value.sub_groups[index],
			updatedSubgroup
		)
	}

	onMounted(() => {
		console.log()
		load()
	})
</script>
